import { usePointsOnboardingDialog } from '@/features/points/dialogs/points-onboarding-dialog/logic/usePointsOnboardingDialog'
import { PointsOnboardingView } from '@/features/points/dialogs/points-onboarding-dialog/views/PointsOnboardingView'
import { DialogContent } from '@/ui/atoms/dialog/Dialog'

interface PointsOnboardingDialogContentContainerProps {
  closeDialog: () => void
}

export function PointsOnboardingDialogContentContainer({ closeDialog }: PointsOnboardingDialogContentContainerProps) {
  const result = usePointsOnboardingDialog({ closeDialog })

  return (
    <DialogContent
      className="bg-primary-inverse"
      spacing="none"
      showCloseButton={false}
      onInteractOutside={result.onCloseEvent}
      onEscapeKeyDown={result.onCloseEvent}
    >
      <PointsOnboardingView {...result} />
    </DialogContent>
  )
}
